import { CopyOutlined } from "@ant-design/icons";
import { IconBaseProps } from "@ant-design/icons/lib/components/Icon";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../configureStore";
import { ERROR_MESSAGE, SUCCESSFUL_MESSAGE } from "../../redux/reducer/status";

interface CopyParams extends IconBaseProps {
    text: string;
}

const Copy = ({
    text,
    ...otherProps
}: CopyParams) => {
    const dispatch = useDispatch<AppDispatch>();

    const onClick = useCallback(() => {
        navigator.clipboard.writeText(text).then(() => {
            dispatch({
                type: SUCCESSFUL_MESSAGE,
                message: 'Copied to the clipboard!',
            });
        }).catch(() => {
            dispatch({
                type: ERROR_MESSAGE,
                message: 'Something went wrong copying to the clipboard!',
            });
        });
    }, [text])

    return (
        <CopyOutlined {...otherProps} onClick={onClick} />
    );
};

export default Copy;
